import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import { useQuery } from '@apollo/react-hooks';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { t } from 'ttag';
import useUser from '../hooks';
import FormField from '../../components/FormField/FormField';
import { clubsQuery } from '../queries';
import { getLoginUrl } from '../urls';
import MyLink from '../../components/Locale/MyLink';

import win from '../win.jpg';

function Copyright() {
  return (
    <Typography variant='body2' color='textSecondary' align='center'>
      {'Copyright © '}
      <Link color='inherit' href='https://myclub.karate.ua'>
        myclub.karate.ua
      </Link>{' '}
      {new Date().getFullYear()}.
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage: `url(${win})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light'
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const getInitialState = () => ({
  email: '',
  password: '',
  club: null,
});

const RegistrationView = ({ clubs }) => {
  const classes = useStyles();

  const { login, errors } = useUser();
  const [state, setState] = React.useState(getInitialState());

  const onChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const handleOnSubmit = () => {
    login(state.email, state.password);
  };

  return (
    <Grid container component='main' className={classes.root}>
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} className={classes.image} />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component='h1' variant='h5'>
            {t`Зареєструватися`}
          </Typography>
          <form className={classes.form} noValidate>
            <FormField
              required
              fullWidth
              type='select'
              margin='normal'
              label={t`Оберіть клуб`}
              id='club'
              name='club'
              autoComplete='club'
              variant='outlined'
              value={state.club}
              errors={errors.gender}
              labelKey='fullName'
              options={clubs}
              onChange={onChange}
            />
            <FormField
              required
              fullWidth
              type='text'
              margin='normal'
              label={t`Прізвище`}
              id='lastName'
              name='lastName'
              autoComplete='lastName'
              variant='outlined'
              value={state.lastName}
              errors={errors.last_name}
              onChange={onChange}
            />
            <FormField
              required
              fullWidth
              type='text'
              margin='normal'
              label={t`Ім'я`}
              id='firstName'
              name='firstName'
              autoComplete='firstName'
              variant='outlined'
              value={state.firstName}
              errors={errors.first_name}
              onChange={onChange}
            />
            <FormField
              required
              fullWidth
              type='text'
              margin='normal'
              label={t`По-батькові`}
              id='middleName'
              name='middleName'
              autoComplete='middleName'
              variant='outlined'
              value={state.middleName}
              errors={errors.middle_name}
              onChange={onChange}
            />
            <TextField
              variant='outlined'
              margin='normal'
              required
              fullWidth
              id='email'
              label='Email'
              name='email'
              autoComplete='email'
              autoFocus
              onChange={onChange}
            />
            <TextField
              variant='outlined'
              margin='normal'
              required
              fullWidth
              name='password'
              label={t`Пароль`}
              type='password'
              id='password'
              autoComplete='current-password'
              onChange={onChange}
            />
            <Button
              type='button'
              fullWidth
              variant='contained'
              color='primary'
              className={classes.submit}
              onClick={handleOnSubmit}
            >
              {t`Зареєструватися`}
            </Button>
            <Grid container>
              <Grid item>
                <MyLink to={getLoginUrl()} variant='body2'>
                  {t`Я вже зареєстрований`}
                </MyLink>
              </Grid>
            </Grid>
            <Box mt={5}>
              <Copyright />
            </Box>
          </form>
        </div>
      </Grid>
    </Grid>
  );
};

const RegistrationViewContainer = () => {
  const { loading, data } = useQuery(clubsQuery, {
    fetchPolicy: 'network-only',
  });

  if (loading) return null;

  return <RegistrationView clubs={data.clubs} />;
};

export default RegistrationViewContainer;
